import { Modal, Table, Form, Button } from "react-bootstrap";
import { useState, useMemo, useEffect } from "react";

export default function MorososModal({
  show,
  onHide,
  morosos = [],
  tipos = {}
}) {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // 🔥 Reset al cerrar modal (UX PRO)
  useEffect(() => {
    if (!show) {
      setSearch("");
      setCurrentPage(1);
    }
  }, [show]);

  // 🔍 Filtrado optimizado
  const filteredMorosos = useMemo(() => {
    const texto = search.toLowerCase();

    return morosos.filter((m) => {
      const nombre = m.nombre?.toLowerCase() || "";
      const apellido = m.apellido?.toLowerCase() || "";
      const rut = m.rut?.toLowerCase() || "";

      return (
        nombre.includes(texto) ||
        apellido.includes(texto) ||
        rut.includes(texto)
      );
    });
  }, [morosos, search]);

  const formatUltimoPago = (num) => {
    if (!num) return "No tiene";

    const valor = String(num).trim();
    const yyyyMm = valor.match(/^(\d{4})(\d{2})$/);

    if (yyyyMm) {
      const year = Number(yyyyMm[1]);
      const month = Number(yyyyMm[2]);

      if (month >= 1 && month <= 12) {
        return new Date(year, month - 1, 1).toLocaleDateString("es-CL", { year: "numeric", month: "long" });
      }
    }

    const date = new Date(num);
    return isNaN(date.getTime()) ? "No tiene" : date.toLocaleDateString("es-CL", { year: "numeric", month: "long" });
  };

  // 📄 Paginación
  const totalPages = Math.ceil(filteredMorosos.length / rowsPerPage);

  const paginatedMorosos = useMemo(() => {
    return filteredMorosos.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );
  }, [filteredMorosos, currentPage, rowsPerPage]);

  const tiposVer = (id) => {
    return tipos[id] || "Desconocido";
  };

  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Listado de Morosos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Controls */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          
          {/* 🔍 Search */}
          <Form.Control
            size="sm"
            type="text"
            placeholder="Buscar por nombre o RUT..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            style={{ minWidth: "220px" }}
          />

          {/* 📊 Rows per page */}
          <div className="d-flex align-items-center gap-2">
            <span>Mostrar:</span>
            <Form.Select
              size="sm"
              style={{ width: "90px" }}
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
            </Form.Select>
          </div>
        </div>

        {/* 📋 Table */}
        <div className="table-responsive">
          <Table striped hover className="mb-4">
            <thead className="text-center">
              <tr>
                <th>N° Socio</th>
                <th>Nombre</th>
                <th>RUT</th>
                <th>Tipo</th>
                <th>Último Pago</th>
              </tr>
            </thead>

            <tbody>
              {paginatedMorosos.length > 0 ? (
                paginatedMorosos.map((m) => (
                  <tr key={m.n_socio}>
                    <td>{m.n_socio}</td>
                    <td>{m.nombre} {m.apellido}</td>
                    <td>{m.rut}</td>

                    {/* 🔥 usamos tipos reales */}
                    <td>{tiposVer(m.tipo_socio)}</td>

                    <td>{formatUltimoPago(m.ultimo_pago_num)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-3">
                    No se encontraron registros
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* 📄 Pagination */}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div className="text-muted small">
            Página {currentPage} de {totalPages || 1}
          </div>

          <div className="d-flex gap-2">
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              ← Anterior
            </Button>

            <Button
              size="sm"
              variant="outline-secondary"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Siguiente →
            </Button>
          </div>
        </div>

      </Modal.Body>
    </Modal>
  );
}